module.exports = __webpack_public_path__ + "img/yl.adc60b8a.png";